import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { dateToEpochString } from '@flipster/utils/datetime';

import { detailBunja } from './details';
import { updateV2SocketData } from './internal/v2-helper';
import { refDetailTimes } from './server-time';
import { r230522SocketBunja } from './socket';
import { WsV2TableEvent } from './types';

export type PswapDetails = Record<string, PswapDetail> | null;

export interface PswapDetail {
  indexPrice: string;
  midPrice?: string;
  askPrice: string;
  bidPrice: string;
  isTradable: boolean;
  bboPriceTimestamp: string;
}

function updatePswapDetails(prev: PswapDetails, wsData: WsV2TableEvent<PswapDetail>['data']) {
  const pswapDetails = updateV2SocketData(prev || {}, wsData);
  if (pswapDetails) {
    Object.entries(pswapDetails).forEach(([key, value]) => {
      // 서버에서 타입 설정을 잘못해서 number 로 오는중
      refDetailTimes[key] = {
        refServerTimestamp: value.bboPriceTimestamp.toString(),
        refClientTimestamp: dateToEpochString(new Date()),
      };
    });
  }
  return pswapDetails;
}

const pswapDetailsAtom = atom<PswapDetails>(null);
export const pswapDetailsBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  const store = bunja.use(JotaiStoreScope);
  const { setCurrentPswapDetail } = bunja.use(detailBunja);
  function setCurrentSymbol(symbol: string | null = null) {
    setCurrentPswapDetail(symbol);
  }

  bunja.effect(() => {
    function pswapDetailshandler(event: WsV2TableEvent<PswapDetail>) {
      if (!event.data) return;
      store.set(pswapDetailsAtom, (prev) => updatePswapDetails(prev, event.data));
    }

    r230522Socket.on('market/pswap-details', pswapDetailshandler);

    return () => {
      setCurrentSymbol(null);
      r230522Socket.off('market/pswap-details', pswapDetailshandler);
    };
  });

  return {
    pswapDetailsAtom,
    setCurrentSymbol,
  };
});
pswapDetailsBunja.debugLabel = 'pswapDetailsBunja';
